module.exports = __webpack_public_path__ + "static/globalzoom-c27b373c5423d7bfcb02b68c0fc49200.png";